import script from "./SettingsPagesEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPagesEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPagesEmptyState.vue?vue&type=style&index=0&id=f68731d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f68731d8"]])

export default __exports__